import { render, staticRenderFns } from "./faceRecognition.vue?vue&type=template&id=66518447&scoped=true"
import script from "./faceRecognition.vue?vue&type=script&lang=js"
export * from "./faceRecognition.vue?vue&type=script&lang=js"
import style0 from "./faceRecognition.vue?vue&type=style&index=0&id=66518447&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66518447",
  null
  
)

export default component.exports